import {Org} from "../../../resources/org"
import React from "react"
import {MainSection} from "../../../containers/MainSection/MainSection"
import {Customer} from "../../../resources/customer"
import OrgOverview from "../OrgOverview"
import OrgTitleBar from "./OrgTitleBar"

interface OrgPageWithoutOnBoardingRulesProps {
	org: Org
	customers: Customer[]
	refresh: () => void
	currentDefaultBankName?: string
	bankNames?: string[]
}

export default function OrgPageWithoutOnboardingRules({
	org,
	customers,
	refresh,
	currentDefaultBankName,
	bankNames,
}: OrgPageWithoutOnBoardingRulesProps) {
	return (
		<>
			<OrgTitleBar org={org} customers={customers} refresh={refresh} />
			<MainSection>
				<OrgOverview
					org={org}
					currentDefaultBankName={currentDefaultBankName}
					customers={customers}
					bankNames={bankNames}
					refresh={refresh}
				/>
			</MainSection>
		</>
	)
}
